import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Field, reduxForm, Form, change } from 'redux-form';
import Button from 'material-ui/Button';
import { MenuItem } from 'material-ui/Menu';
import Paper from 'material-ui/Paper';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';

import { CircularProgress } from 'material-ui/Progress';
import Fade from 'material-ui/transitions/Fade';

import Layout from '../components/Layout';
import validationHelper from '../helpers/ValidationHelper';
import AutoComplete from '../helpers/AutoComplete';

import getUserLocations from '../actions/getUserLocations';
import getPerson from '../actions/getPerson';
import { clearRoutes } from '../actions/getRoutes';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
    justifyContent: 'center'
  },
  content: {
    display: 'flex',
    justifyContent: 'center'
  },
  paperStyle: {
    width: '40%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '13vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 320,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 6px -2px rgba(0,0,0,0.2)',
    borderBottom: '1px solid #e0e0e0',
  },
  headerTitleStyle: {
    flexDirection: 'column',
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto'
  }
});

const validate = (values) => {
  const errors = validationHelper.validateRequired(['selectLocation'], values);
  return errors;
};

class LocationSelector extends Component {
  state = {
    locations: [],
    selectedLocation: [],
  }

  componentDidMount() {
    this.props.actions.getUserLocations(this.props.data.config, this);
  }

  setLocation = (locationId) => {
    if (locationId) {
      localStorage.setItem('locationId', locationId);
      // get the person
      this.props.actions.getPerson(null, this.props.data.login.sub, this.props.data.config);
    }

    // set customer id for this location
    const location = this.props.data.userLocations.userLocations.find((l) => l.locationId === locationId);
    if (location) {
      this.setCustomer(location.customerId);
    }

    this.props.history.push('/');
    this.props.actions.clearRoutes();
  }

  setCustomer = (customerId) => {
    if (!customerId) return;

    localStorage.setItem('customerId', customerId);
  }

  handleSave = () => {
    this.setLocation(this.state.selectedLocation);
    this.setCustomer(this.state.selectedLocation.customerId);
  }

  handleChangedLocations = (value) => {
    if (!value) {
      this.setState({ selectedLocation: {} });
      return;
    }
    this.setState({ selectedLocation: value });
    
  }

  render() {
    const { classes, handleSubmit } = this.props;
    if (this.props.data.userLocations.userLocations && localStorage.getItem('locationId') === '') {
      if (this.props.data.userLocations.userLocations.length === 1) {
        this.setLocation(this.props.data.userLocations.userLocations[0].locationId);
      }
    }
    let suggestions = [];
    const { locations } = this.state;
    if (locations && Array.isArray(locations)) {
      suggestions = locations.map(l => ({
        value: l.locationId,
        label: l.locationName
      }));
    }
    const selectedSuggestions = this.state.selectedLocation;

    return (
      <Layout className="App" showMenu menuTitle="Location Selector" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727." >
        {
          !this.props.data.userLocations.fetching &&
          <Paper className={classes.paperStyle}>
            <AppBar position="static" className={classes.headerStyle}>
              <Toolbar className={classes.headerTitleStyle}>
                <Typography variant="title">
                  Select Location
                </Typography>
              </Toolbar>
            </AppBar>
            <Form onSubmit={handleSubmit(this.handleSave)}>
              <Card className={classes.card}>
                <CardContent className={classes.content}>
                  <div style={{ width: '400px' }}>
                    <AutoComplete
                      onChange={this.handleChangedLocations}
                      selectedSuggestions={selectedSuggestions}
                      suggestions={suggestions}
                      label="Locations"
                      placeholder="Select Location"
                    />
                  </div>
                </CardContent>
              </Card>
              <div className={classes.buttonStyle}>
                <Button variant="raised" color="primary" type="submit">Submit</Button>
              </div>
            </Form>
          </Paper>
        }
        <div>
          <Fade
            in={this.props.data.userLocations.fetching}
            style={{
              transitionDelay: this.props.data.userLocations.fetching ? '800ms' : '0ms'
            }}
            unmountOnExit
          >
            <CircularProgress style={{ marginTop: '10%' }} />
          </Fade>
        </div>
      </Layout>
    );
  }
}

LocationSelector.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  data: {
    config: state.config.config,
    login: state.login.login,
    userLocations: state.userLocations
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getUserLocations: (config, self) => {
      dispatch(getUserLocations(config, self)).then((locations) => {
        const locationItems = locations.value.data.map(location => ({
          locationId: location.locationId,
          locationName: location.locationName,
        }));

        // sort them
        locationItems.sort((a, b) => a.locationName.localeCompare(b.locationName));
        self.setState({ locations: locationItems });
      });
    },
    getPerson: (email, cognitoId, config) => {
      dispatch(getPerson(email, cognitoId, config));
    },
    clearRoutes: () => {
      clearRoutes(dispatch);
    },
  }
});

const ConnectedLocationSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: 'LocationSelector', validate })(LocationSelector));

export default withStyles(styles, { withTheme: true })(ConnectedLocationSelector);


// WEBPACK FOOTER //
// ./src/containers/LocationSelector.js